import React from "react";

export default function ImageToPdf() {
  return (
    <div className="space-y-4">
      <h2 className="text-xl font-semibold">Convert JPG/PNG to PDF</h2>
      <p>This tool will be implemented here. File conversion logic will run in the browser.</p>
    </div>
  );
}
